import { render, staticRenderFns } from "./Bots.vue?vue&type=template&id=1499af06&scoped=true"
import script from "./Bots.vue?vue&type=script&lang=js"
export * from "./Bots.vue?vue&type=script&lang=js"
import style0 from "../assets/sass/commponents/bots.scss?vue&type=style&index=0&id=1499af06&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1499af06",
  null
  
)

export default component.exports